import { apiRexxbot } from "../../../../services/apiRexxbot";

export const sendLeadWhatsapp = async (data, type) => {
	await apiRexxbot.post("sendLead", { ...data, sender: "InoveClube", type: type });
};
